<h1 mat-dialog-title>{{ modalContent.title }}</h1>
<p>{{ modalContent.message }}</p>
<div mat-dialog-actions class="actions">
    <button type="button" class="btn btn--outline-grey-color water-transaction-spacer" mat-dialog-close (click)="onActionTaken(false)">{{ 'action.cancel' | translate }}</button>
    <button type="button" class="btn btn--primary" cdkFocusInitial (click)="onActionTaken(true)">{{ modalContent.ok }}</button>
</div>


